import React, { Component } from "react";
import * as s from "./FilterModal.module.scss";
import {
  P,
  Checkbox,
  Button,
  Modal,
} from "resource-centre-theme/src/views/shared/components";
import { inject, observer } from "mobx-react";
import { tx } from "resource-centre-theme/src/libs/i18n";
import { FilterStore } from "resource-centre-theme/src/stores";
interface Props {
  title: string;
  options?: any;
  onClose: () => void;
  open: boolean;
  filterStore?: FilterStore;
}

interface State {
  searchTerm: string;
}

@inject("filterStore")
@observer
export class FilterModal extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { searchTerm: "" };
  }

  renderOption = (item, key) => {
    const { options, filterStore } = this.props;
    const { toggleOption } = filterStore;
    const { value, numberOfDocuments, selected } = item;
    let dropdownItemClasses = [s.dropdownItem];
    let formattedValue = numberOfDocuments
      ? value + ` (${numberOfDocuments})`
      : value;

    return (
      <div className={dropdownItemClasses.join(" ")} key={key}>
        <Checkbox
          type="check"
          onChange={() => {
            toggleOption(options, item);
          }}
          selected={selected}
        />
        <div className={s.dropdownItemLabelContainer}>
          <P className={s.dropdownItemLabel}>{formattedValue}</P>
        </div>
      </div>
    );
  };

  render() {
    const { title, onClose, open, options } = this.props;
    const { searchTerm } = this.state;
    const filterDropdownClasses = [s.filterDropdown];
    const dropdownItemsClasses = [s.dropdownItems];

    return (
      <Modal open={open} onClose={onClose} title={title}>
        <div className={s.heroCountryOverlay}>
          <h3 className={s.overlayTitle}>{title}</h3>
          <input
            value={searchTerm}
            onChange={e => this.setState({ searchTerm: e.target.value })}
            className={s.searchFilter}
            placeholder={`Search ${title.toLowerCase()}`}
          />
          <div className={filterDropdownClasses.join(" ")}>
            <div className={dropdownItemsClasses.join(" ")}>
              {options
                ?.filter(o =>
                  searchTerm?.length > 2
                    ? o?.value
                        ?.toLowerCase()
                        ?.includes(searchTerm.toLowerCase())
                    : true
                )
                .map(this.renderOption)}
            </div>
          </div>
          <div className={s.buttonContainer}>
            <Button
              size="medium"
              color="red"
              className={s.searchQueryButton}
              onClick={onClose}
            >
              {tx("misc.select")}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
